var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appPage"},[_c(_vm.headerType,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"contentDIV"},[_c('nuxt')],1),_vm._v(" "),_c(_vm.footerType,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }